export default __webpack_public_path__ + "static/media/Time_11.4f149a21.png";